import React,{Component} from 'react';
import {connect} from 'react-redux'
import { validURL, l, getLangLabel, pagesOptions } from '../functions';
import ListSortedItemsCheckboxes from './ListSortedItemsCheckboxes';
import ProductFilter from './ProductFilter';
import Icon from './Icons';
import {TextField,Select} from './FormElements';
import Switch from '@material-ui/core/Switch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const mapStateToProps = state => {
    return { 
        fetchedPages: state.rootReducer.fetchedPages || [],
        fetchedCategories: state.rootReducer.fetchedCategories || {},
        fetchedLangs: state.rootReducer.fetchedLangs || [],
        currentLang: state.rootReducer.currentLang || 1,
    };
};
class ListDialog extends Component {
	constructor(props) {
        super(props);

        this.state = {
            linkType : '',
            item : null,
            searchIcon: ''
        }
    }

    componentDidMount(){
        this.setState({item: this.props.listDatas});
    }

    _changedField = (key,value) => {
        this.setState({
            ...this.state,
            item: {
                ...this.state.item,
                content : (key === 'title_1')?value.substring(0,16)+((value.length > 16)?'...':''):this.state.item.content,
                data : {
                    ...this.state.item.data,
                    [key]: value
                }
            }
        })
    }

    _changedIcon = (index,value = 0,cb = () => {}) => {
        this.setState({
            ...this.state,
            item: {
                ...this.state.item,
                content : this.state.item.content,
                data : {
                    ...this.state.item.data,
                    [index]: value
                }
            }
        },() => {
            cb();
        })
    }

    render() {
        return (
            <div className="list-dialog">
                <div className="head">
                    <Icon icon="time" onClick={this.props.onClose} /> <h3>{l('Edit item')}</h3>
                    <button className="new-item" onClick={() => {this.props.onSubmit(this.state.item)}}><Icon icon="check" /></button>
                </div>
                <div className="form">
                    {
                        this.props.fetchedLangs && this.props.fetchedLangs.map((lang, index) => (
                            this.props.currentLang == lang.value && 
                            <div key={index} className="section">
                                <TextField
                                    label={l('Title')+' ('+getLangLabel()+')'}
                                    value={this.state.item && this.state.item.data && this.state.item.data['title_'+lang.value] || ''}
                                    onChange={(value) => { this._changedField('title_'+lang.value,value) }}
                                    solid dark
                                />
                            </div>
                        ))
                    }
                    <hr />
                    <div className="section">
                        <div className="gk-form-row-container">
                            <label className="small">{l('This item has a link')}</label>

                            <Switch
                                checked={this.state.item && this.state.item.data && this.state.item.data.isUrl || false}
                                onChange={(e) => { this._changedField('isUrl',e.target.checked) }}
                            />
                        </div>
                    </div>
                    {
                        this.state.item && this.state.item.data && this.state.item.data.isUrl && 
                        <div className="section">
                            <ul className="inline-options dark grow">
                                <li onClick={() => {this._changedField('target','_self')}} className={(this.state.item && this.state.item.data && this.state.item.data.target !== '_blank')?"selected":"" }><span>{l('Same window')}</span></li>
                                <li onClick={() => {this._changedField('target','_blank')}} className={(this.state.item && this.state.item.data && this.state.item.data.target === '_blank')?"selected":"" }><span>{l('New window')}</span></li>
                            </ul>
                        </div>
                    }

                    {
                        this.state.item && this.state.item.data && this.state.item.data.isUrl && 
                        <div className="section">
                            <div className="gk-form-row-container">
                                <label className="small">{l('Link type')}</label>
                                <Select
                                    placeholder={l('Link type')}
                                    value={this.state.item && this.state.item.data && this.state.item.data.linkType || ''}
                                    onChange={(value) => { this._changedField('linkType',value) }}
                                    options={
                                        [
                                            {
                                                label : l('Custom'),
                                                value : 'custom'
                                            },
                                            {
                                                label : l('Product'),
                                                value : 'product'
                                            },
                                            {
                                                label : l('Category'),
                                                value : 'category'
                                            },
                                            {
                                                label : l('Page'),
                                                value : 'cms'
                                            }
                                        ]
                                    }
                                    dark
                                />
                            </div>
                        </div>
                    }
                    {
                        this.state.item && this.state.item.data && this.state.item.data.isUrl && this.state.item.data.linkType && this.state.item.data.linkType === 'product' &&
                        <div className="section">
                            <ProductFilter
                                label={l('Filter product')}
                                list={( this.state.item && this.state.item.data && this.state.item.data.url && this.state.item.data.url.includes("product__") )?this.state.item.data.url.replace('product__',''):''}
                                onCheck={(product) => {this._changedField('url','product__'+product)}}
                            />
                        </div>
                    }

                    {
                        this.state.item && this.state.item.data && this.state.item.data.isUrl && this.state.item.data.linkType && this.state.item.data.linkType === 'category' &&
                        <div className="section">
                            <label className="small">{l('Select a category')}</label>
                            <ListSortedItemsCheckboxes
                                list={( this.state.item && this.state.item.data && this.state.item.data.url && this.state.item.data.url.includes("category__") )?this.state.item.data.url.replace('category__',''):''}
                                onCheck={(list) => {this._changedField('url','category__'+list)}}
                                items={this.props.fetchedCategories.leveled}
                                inlineItems={this.props.fetchedCategories.normal}
                            />
                        </div>
                    }

                    {
                        this.state.item && this.state.item.data && this.state.item.data.isUrl && this.state.item.data.linkType && this.state.item.data.linkType === 'cms' &&
                        <div className="section">
                            <div className="gk-form-row-container">
                                <label className="small">{l('Page')}</label>
                                <Select
                                    placeholder={l('Select page')}
                                    value={this.state.item && this.state.item.data && this.state.item.data.url && this.state.item.data.url.includes('cms__') && this.state.item.data.url || ''}
                                    onChange={(value) => { this._changedField('url',value) }}
                                    options={pagesOptions('cms')}
                                    dark
                                />
                            </div>
                        </div>
                    }

                    {
                        this.state.item && this.state.item.data && this.state.item.data.isUrl && this.state.item.data.linkType && this.state.item.data.linkType === 'custom' && 
                        <div className="section">
                            <TextField
                                placeholder={l('Custom url')}
                                info={l('Secured link is recommanded')}
                                value={(this.state.item && this.state.item.data && this.state.item.data.url && this.state.item.data.url.includes("custom__")) ? this.state.item.data.url.replace('custom__','') : ''}
                                onChange={(value) => { this._changedField('url','custom__'+value) }}
                                dark
                                error={(!validURL(( this.state.item && this.state.item.data && this.state.item.data.url && this.state.item.data.url.includes("custom__"))?this.state.item.data.url.replace('custom__',''):''))?l('Url format not correct'):false}
                            />
                        </div>
                    }

                    {
                        this.state.item && this.state.item.data && this.state.item.data.isUrl && this.state.item.data.linkType && this.state.item.data.linkType === 'popup' &&
                        <div className="section">
                            <div className="gk-form-row-container">
                                <label className="small">{l('Popup')}</label>
                                <Select
                                    placeholder={l('Select popup')}
                                    value={this.state.item && this.state.item.data && this.state.item.data.url && this.state.item.data.url.includes('modal_payload__') && this.state.item.data.url || ''}
                                    onChange={(value) => { this._changedField('url',value) }}
                                    options={pagesOptions('modal_payload')}
                                    dark
                                />
                            </div>
                        </div>
                    }
                    <hr />
                    <div className="section">
                        <div className="gk-form-row-container">
                            <label className="small">{l('Add font awesome icon')}</label>

                            <Switch
                                checked={this.state.item && this.state.item.data && this.state.item.data.useFAIcon || false}
                                onChange={(e) => { this._changedField('useFAIcon',e.target.checked) }}
                            />
                        </div>
                    </div>
                    {
                        this.state.item && this.state.item.data && this.state.item.data.useFAIcon && 
                        <div className="section">
                            <label className="small">{l('Icons list')}</label>
                            <TextField
                                placeholder={l('Search Icon')}
                                value={this.state.searchIcon || ''}
                                onChange={(value) => { this.setState({searchIcon:value}) }}
                                dark
                            />
                            <div className="fa-icon-container">
                                {
                                    this.props.iconsList.map((icon,index) => (
                                        icon[1].match(new RegExp(this.state.searchIcon, "i")) && <span className={this.state.item && this.state.item.data && this.state.item.data.iconFAClass === icon && 'active' || ''} key={index} onClick={() => {this._changedField('iconFAClass',icon)}}><FontAwesomeIcon icon={[icon[0],icon[1]]} /></span>
                                    ))
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(ListDialog)